import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { applyMiddleware } from 'redux';
import { createStore } from 'redux-dynamic-modules-core';
import { getSagaExtension } from 'redux-dynamic-modules-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import ddt from '@wix/da-ddt';
import { shouldLogError } from '../../ErrorBoundary/ErrorBoundary';
export function rootModuleStoreFactory(middlewares, logger, initialState, rootReducer, rootSaga, useOld = true) {
    // @ts-ignore
    const sagaExt = getSagaExtension(undefined, (error, stack)=>{
        logger.error('Uncaught error in saga', error, stack);
        if (!shouldLogError(error)) {
            return;
        }
        ddt.alert('redux', `Saga crashed: ${error && error.message || 'unknown'}`, [
            'fatal'
        ], {
            stacktrace: error && error.stack,
            sagastack: stack
        });
    });
    const store = createStore({
        initialState,
        extensions: [
            sagaExt
        ],
        enhancers: [
            applyMiddleware(...middlewares)
        ],
        advancedComposeEnhancers: composeWithDevTools({})
    }, getRootModule(rootReducer, rootSaga));
    return store;
}
function getRootModule(rootReducer, rootSaga) {
    return {
        id: 'rootModule',
        reducerMap: _object_spread({}, rootReducer),
        sagas: [
            rootSaga
        ],
        retained: true
    };
}
